<!-- Breadcrumb -->
<div class="pag-container">
  

<!-- TODO Router BreadCrubm hardcoddato a campaign-list-3 -->
  <app-campaign-3-breadcrumb #breadcrumbComponent  [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink="">
  </app-campaign-3-breadcrumb>

  <!-- Bottoni gialli di lista azioni e creazione -->
  <div class="ui-g-12 d-flex justify-content-center">

    <div class="ui-g-7">
    </div>
    <div class="ui-g-5 footer-btn-container">

      <button class="btn-page-act" (click)="onAddAccumulator()">
        <i class="pi pi-plus"></i> <span> Inserisci nuovo accumulatore </span>
      </button>
    </div>
  </div>



  <div class="ui-g-12 prova">
    <!--customExpandedRowTemplate contiene il template che si vuole applicare dentro riga espansa  -->
    <app-campaign-3-kontable *ngIf="readyTable" #acmTable
    [columns]="[
      {
        field: 'channel_id',
        title: 'acm.channel_id',
        filterType: selectFilter,
        filterOptions: { values: listChannelsSelect },
        bodyTemplate: channelDescriptionTemplate
      },
      {
        title: 'acm.acm_code',
        field: 'acm_code',
        filterType: textFilter,
        bodyTemplate: acmCodeTemplate
      },
      {
        title: 'acm.acmDescription',
        field: 'acmDescription',
        filterType: textFilter,
        bodyTemplate: acmCodeDescriptionTemplate
      },
      {
        field: 'acmTypeDescription',
        title: 'acm.acm_type_id',
        filterType: selectFilter,
        bodyTemplate: accumulatorDescriptionTemplate,
        filterOptions: { values: listAcmTypes }
      },
      {
        field: 'status',
        title: 'common.validity',
        filterType: selectFilter,
        bodyTemplate: activationStateTemplate,
        filterTemplate: activationStateTemplateFilter,
        filterOptions: { values: listActivationStates }
      },
      {
        field: 'flg_state',
        title: 'common.status',
        filterType: selectFilter,
        bodyTemplate: stateTemplate,
        filterTemplate: customerStateFilter,
        filterOptions: { values: listStates }
      },
      {
        field: 'date_start',
        title: 'acm.date_start',
        filterType: customFilter,
        filterTemplate: dateStartFilter,
        bodyTemplate: startDateTemplate
      },
      {
        field: 'date_end',
        title: 'acm.date_end',
        filterType: customFilter,
        filterTemplate: dateEndFilter,
        bodyTemplate: endDateTemplate
      }
    ]"
    [service]="acmService"
    [paginationType]="paginationType"
    [additionalRowCommands]="actions"
    [expandTable]="expandTable"
    [fetchActionListAsap]="fetchActionListAsap"
    [subjectToLoad]="pageSubject"
    [filterBySingleColumn]="false"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [titles]="['acm.acm_code', 'acm.description', 'acm.status']"
    [servicePermissions]="acmPermission"
    [(fireNewDataAvailable)]="newDataAvailable"
    (onRecover)="recover($event)"
    (onAdd)="add($event)"
    (onEdit)="edit($event)"
    (onRemove)="remove($event)"
    [showGlobalFilter]="true"
    [customExpandedRowTemplate]="customTemplate"
    [fetchAcmListAsap]="true"

    >

    <ng-template #customTemplate let-loadedAccumulator="loadedAccumulator" let-acmLoyChannelList="acmLoyChannelList" let-row>

      <ng-container *ngIf="loadedAccumulator">
        <app-acm-detail-3
           (refreshPage)="refreshAfterCreate($event)" 
           [acmLoyChannelList]="acmLoyChannelList"
           [fatherAcmChannel]="row"
            [loadedAccumulator]="loadedAccumulator"></app-acm-detail-3>
          
      </ng-container>

    </ng-template>


      <ng-template #channelDescriptionTemplate let-row>
        <span [ngClass]="checkExpiredAcm(row)">{{row.channelDescription}}</span>
      </ng-template>

      <ng-template #acmCodeTemplate let-row>
        <span [ngClass]="checkExpiredAcm(row)">{{row.acm_code}}</span>
      </ng-template>


      <ng-template #acmCodeDescriptionTemplate let-row>
        <span [ngClass]="checkExpiredAcm(row)">{{row.acmDescription}}</span>
      </ng-template>

      <ng-template #accumulatorDescriptionTemplate let-row>
        <span [ngClass]="checkExpiredAcm(row)">{{row.acmTypeDescription}}</span>
      </ng-template>
      <ng-template #startDateTemplate let-row>
        <span [ngClass]="checkExpiredAcm(row)"> {{ row.dateStart |
          date:srvCalendar.pcalendarTranslate.dateFormatFilter }}</span>
      </ng-template>

      <ng-template #endDateTemplate let-row>
        <span [ngClass]="checkExpiredAcm(row)">{{ row.dateEnd |
          date:srvCalendar.pcalendarTranslate.dateFormatFilter }}</span>
      </ng-template>

      <ng-template #dateStartFilter let-col>
        <span></span>
      </ng-template>


      <ng-template #dateEndFilter let-col>
        <span></span>
      </ng-template>


      <ng-template #pAcmTypeTemplateFilter let-col>
        <p-dropdown [options]="listAcmTypes" [style]="{'width':'100%'}"
          (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
      </ng-template>

      <ng-template #pChannelTemplateFilter let-col>
        <p-dropdown [options]="listChannelsSelect"
          (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
      </ng-template>

      <ng-template #activationStateTemplateFilter let-col>
        <p-dropdown [options]="listActivationStates"
          (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
      </ng-template>

      <ng-template #stateTemplate let-row class="deleted-row">
       <span>{{getAcmStatus(row)}}</span>
      </ng-template>

      <ng-template #activationStateTemplate let-row>
        <span *ngIf="getStatus(row) == 'expired'" [ngClass]="checkExpiredAcm(row)"> {{ 'acm.expired' | translate
          }}</span>
        <span *ngIf="getStatus(row) == 'valid'"> {{ 'acm.valid' | translate }}</span>
        <span *ngIf="getStatus(row) == 'future'"> {{ 'acm.future' | translate }}</span>
      </ng-template>

      <ng-template #customerStateFilter let-col>
        <p-dropdown [options]="listStates" [style]="{'width':'100%'}"
          (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
      </ng-template>

      <ng-template #actions let-row>

        <div class="d-flex ">
          <button pTooltip="{{ 'common.edit' | translate }}" class="roundedButton row-buttom-margin"
            (click)="onOpenEdit(row)">
            <i class="pi pi-pencil icon-size"></i>
          </button>
          <button pTooltip="{{ 'common.actions' | translate }}" class="roundedButton" (click)="toggleMenu(row.id)">
            <i class="pi pi-ellipsis-h icon-size"></i>
          </button>

        </div>

        <div class="dropdown-menu" *ngIf="showMenu && row.id == currentOpenedRow">

        <!--   <button class="dropdown-item" (click)="a1()">{{ 'common.deleteNew' | translate }}</button> -->
        <button
        [ngClass]="{'not-permitted': checkAlreadyDeleted(row)}"
        [disabled]="checkAlreadyDeleted(row)"
        class="dropdown-item"
        (click)="deleteAccumulator(row)">
        {{ 'common.deleteNew' | translate }}
      </button>
      


        </div>

    

      </ng-template>





    </app-campaign-3-kontable>



  </div>



  <p-dialog
header="{{ 'acm.confirm_delete' | translate }}"
  [(visible)]="displayDeleteDialog"
  modal="modal"
  [closable]="false"
  class="custom-dialog">

  <div>{{ 'acm.confirm_delete_message' | translate }} </div>


  <div class="custom-footer">
    <button type="button" pButton label="{{ 'common.cancel' | translate }}" (click)="closePopupDelete()" icon="pi pi-times"></button>
    <button type="button" pButton label="{{ 'common.confirm' | translate }}"  (click)="onDefinitiveDelete(accToDelete)" icon="pi pi-check" style="margin-left: .25em"></button>
  </div>
</p-dialog>


</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty-3/loyalty-acm-3/loyalty-acm-3.component.html